import { render } from "./modals.vue?vue&type=template&id=c6fab2fa&scoped=true"
import script from "./modals.vue?vue&type=script&lang=js"
export * from "./modals.vue?vue&type=script&lang=js"

import "./modals.vue?vue&type=style&index=0&id=c6fab2fa&lang=scss&scoped=true"

import exportComponent from "/Users/mirox/Desktop/coreui-free-vue-admin-template-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6fab2fa"]])

export default __exports__